import { render, staticRenderFns } from "./HomeScroll.vue?vue&type=template&id=201fccea&scoped=true&"
import script from "./HomeScroll.vue?vue&type=script&lang=js&"
export * from "./HomeScroll.vue?vue&type=script&lang=js&"
import style0 from "./HomeScroll.vue?vue&type=style&index=0&id=201fccea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201fccea",
  null
  
)

export default component.exports